var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileyHeartWithRainbowTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1958 46.6555H25.501C25.501 32.1326 16.481 20.6889 5.88354 20.6889V14.9941C20.4508 14.9941 31.1958 29.8166 31.1958 46.6555Z",
    fill: "#9E56DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5057 46.6555H29.8109C29.8109 32.1326 20.7909 20.6889 10.1935 20.6889V14.9941C24.7716 14.9941 35.5057 29.8297 35.5057 46.6555Z",
    fill: "#792CB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8163 46.6555H34.1215C34.1215 32.1326 25.1015 20.6889 14.504 20.6889V14.9941C29.0827 14.9941 39.8163 29.8331 39.8163 46.6555Z",
    fill: "#A7C41A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8137 15.7259C33.4545 15.5659 43.8224 30.4954 44.126 46.6555H38.4312C38.7307 31.4475 29.2643 20.0892 18.8137 19.9571C19.0905 19.4594 19.3832 15.7196 18.8137 15.7259Z",
    fill: "#FEDD73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1237 16.988C35.999 16.451 47.6011 29.1903 48.4359 46.6557H42.7411C43.564 31.0474 34.0429 19.1657 23.1237 18.6959C23.4169 18.2079 23.6926 16.9641 23.1237 16.988Z",
    fill: "#EB5E47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7382 4.47042C17.7382 4.47042 14.7592 0 8.87307 0C-0.706157 0 -8.14927 16.9352 17.7382 29.8015C43.5014 16.9967 36.289 0 26.6033 0C20.7165 0 17.7382 4.47042 17.7382 4.47042Z",
    fill: "#FD9CAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9596 12.8227C21.2352 12.8119 21.1122 9.61085 22.758 9.27201C24.9288 8.82554 24.8127 12.8341 22.9596 12.8227Z",
    fill: "#434547"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2479 12.8227C10.5235 12.8119 10.4005 9.61085 12.0463 9.27201C14.2172 8.82554 14.101 12.8341 12.2479 12.8227Z",
    fill: "#434547"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0171 12.7642C17.8553 12.865 17.6771 12.848 17.5022 12.7716C14.3149 11.3776 20.7881 11.0393 18.0171 12.7642Z",
    fill: "#434547"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6047 18.3838C29.422 21.5131 33.6948 14.8075 29.6031 12.4214C26.0865 10.3707 22.4595 15.8058 25.6047 18.3838Z",
    fill: "#EB5E47"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77911 18.3838C5.96188 21.5131 1.68907 14.8075 5.78079 12.4214C9.29733 10.3707 12.9243 15.8058 9.77911 18.3838Z",
    fill: "#EB5E47"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0271 13.8301C17.9793 16.7236 20.8284 15.9138 19.1814 13.3301C18.6165 13.8853 17.8352 14.0886 17.0271 13.8301Z",
    fill: "#EB5E47"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4318 12.8809C16.8304 15.1219 19.9802 14.2785 20.0565 11.9436C20.0673 11.6139 19.5548 11.6139 19.544 11.9436C19.4848 13.7505 16.9967 14.4208 15.8743 12.6224C15.7 12.3434 15.2564 12.6002 15.4318 12.8809Z",
    fill: "#434547"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3953 13.7622C18.2313 13.4764 17.7882 13.7338 17.9528 14.0208C18.143 14.3528 18.3719 14.6609 18.6339 14.9394C18.8605 15.1802 19.2222 14.8175 18.9961 14.5772C19.0018 14.5772 18.6954 14.2867 18.3947 13.7622H18.3953Z",
    fill: "#434547"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0948 2.9119C29.9519 3.03548 32.297 5.37319 32.2577 8.42333C32.2429 9.55887 33.952 9.54008 33.9662 8.42333C34.0499 1.9472 26.1381 -0.225367 26.2406 2.05768C26.2828 2.99561 27.3329 2.92215 27.0948 2.9119Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0381 10.0371C31.8792 10.0371 31.9452 11.7456 33.0381 11.7456C34.197 11.7456 34.1303 10.0371 33.0381 10.0371Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07907 1.76084C4.39055 1.74319 1.80797 4.02453 1.61776 8.14472C1.56821 9.22103 3.2721 9.32183 3.3262 8.14472C3.46857 5.06554 5.27211 3.45733 7.07907 3.46928C8.22771 3.47669 8.18044 1.76084 7.07907 1.76084Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.046 14.4976C6.59383 14.4053 6.14167 14.3131 5.6895 14.2208C5.36775 14.1553 5.22993 14.6491 5.55339 14.7151C6.00556 14.8074 6.45774 14.8996 6.90991 14.9919C7.26868 15.0654 7.33985 14.4976 7.046 14.4976Z",
    fill: "#434547"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71341 15.4795C6.32673 15.5763 5.93949 15.6731 5.55282 15.7694C5.23277 15.8491 5.36828 16.344 5.6889 16.2637C6.07558 16.1669 6.46285 16.07 6.84952 15.9738C7.11604 15.9072 7.11603 15.4795 6.71341 15.4795Z",
    fill: "#434547"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21332 17.1651C6.45592 17.3878 6.64671 17.0945 6.96277 16.7784C7.20821 16.533 6.83236 16.1839 6.60059 16.4162C6.68829 16.4162 5.89443 16.8724 6.21391 17.1657L6.21332 17.1651Z",
    fill: "#434547"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8797 14.7141C30.2025 14.6481 30.0659 14.1543 29.7436 14.2198C29.2914 14.3121 28.8392 14.4043 28.387 14.4966C28.0642 14.5627 28.2008 15.0564 28.5232 14.9909C29.0926 14.9909 29.4275 14.8064 29.8797 14.7141Z",
    fill: "#434547"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7441 16.2636C30.0642 16.3433 30.2009 15.8495 29.8802 15.7692C29.4936 15.6724 29.1063 15.5756 28.7196 15.4794C28.3996 15.3997 28.2629 15.8934 28.5835 15.9737C29.153 15.9737 29.3574 16.1673 29.7441 16.2636Z",
    fill: "#434547"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2199 17.1645C29.4426 16.9219 29.1493 16.7311 28.8332 16.415C28.5878 16.1696 28.2387 16.5454 28.471 16.7772C28.5382 16.7772 28.9397 17.4697 29.2205 17.1639L29.2199 17.1645Z",
    fill: "#434547"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyHeartWithRainbowTail);
export default __webpack_public_path__ + "static/media/smiley-heart-with-rainbow-tail.1c3cbc5990c341f0fe712e1b36cf8ed0.svg";
export { ForwardRef as ReactComponent };